var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip0_1171_3949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.73938 5.79236C4.90933 6.01956 5.12615 6.20755 5.37513 6.34359C5.62412 6.47962 5.89945 6.56051 6.18245 6.58078C6.46546 6.60105 6.74951 6.56022 7.01534 6.46105C7.28117 6.36189 7.52257 6.20672 7.72316 6.00606L8.91033 4.81888C9.27076 4.4457 9.47019 3.9459 9.46568 3.42711C9.46118 2.90831 9.25309 2.41205 8.88623 2.0452C8.51938 1.67834 8.02311 1.47025 7.50432 1.46574C6.98553 1.46123 6.48572 1.66067 6.11255 2.02109L5.4319 2.69778",
    stroke: "white",
    strokeWidth: 1.18118,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.32156 5.00044C6.15162 4.77325 5.9348 4.58525 5.68581 4.44922C5.43682 4.31319 5.16149 4.23229 4.87849 4.21203C4.59549 4.19176 4.31144 4.23259 4.04561 4.33175C3.77977 4.43092 3.53838 4.58609 3.33779 4.78675L2.15061 5.97393C1.79019 6.3471 1.59075 6.84691 1.59526 7.3657C1.59977 7.88449 1.80786 8.38076 2.17471 8.74761C2.54157 9.11447 3.03783 9.32256 3.55662 9.32706C4.07541 9.33157 4.57522 9.13214 4.94839 8.77171L5.62508 8.09502",
    stroke: "white",
    strokeWidth: 1.18118,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1171_3949"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.49743,
    height: 9.49743,
    fill: "white",
    transform: "translate(0.782715 0.647797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.20565690440d461be39c61b627cf9e04.svg";
export { ForwardRef as ReactComponent };